import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as moment from 'moment';
import 'moment/locale/th';
import NumberFormat from 'react-number-format'
import {  IMAGE_THUMB_URL , IMAGE_FULL_URL  } from '../../../config/config';
import PreviewImage from '../../../views/PreviewImage/'
import {  Modal, ModalBody } from 'reactstrap';

class CarExpenseList extends Component {

    constructor (props) {
        super(props)

        this.state = {
            preview_image_url: '',
            preview_image_select: false
        }

        this.togglePreviewImage = this.togglePreviewImage.bind(this)

    }

    onPreviewSelected(url){
        this.setState({
            preview_image_url: url,
            preview_image_select: true
        });
    }

    togglePreviewImage() {
        this.setState({
            preview_image_select: !this.state.preview_image_select
        });
    }

    render(){
        var car_expense_list = this.props.car_expense_list.map((expense,index)=>{
            return (
                <tr key={index}>
                    <td className="text-center">{expense.expense_id}</td>
                    <td className="text-center">{moment(expense.expense_date).locale('th').format('LL')}</td>
                    <td className="text-center">{expense.branch_name}</td>
                    <td className="text-center">{expense.expense_name}</td>
                    <td className="text-center">
                        <img
                            src={IMAGE_THUMB_URL + expense.expense_image_file}
                            className="img-cars"
                            style={{'cursor':'pointer'}}
                            alt="เอกสาร"
                            onClick={()=>this.onPreviewSelected(IMAGE_FULL_URL + expense.expense_image_file)}
                        />
                    </td>
                    <td className="text-center">
                        <NumberFormat value={expense.expense_amount}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'฿'}/>
                    </td>
                    <td className="text-center">{expense.user_created}
                        <br/>
                        {moment(expense.updated_at).locale('th').format('DD-MM-YYYY HH:mm')}
                    </td>
                  <td>
                    <button className="btn btn-sm btn-danger btn-md-width"
                            onClick={() => this.onDeleteHandle(expense)}
                    >
                      <i className="fa fa-remove"></i> ลบ
                    </button>
                  </td>
                </tr>
            )
        });

      if(this.props.car_expense_list.length === 0){
        car_expense_list = <tr>
          <td colSpan={8} className="text-center text-danger">
            ไม่พบรายการจ่ายอื่นๆ ของรถ
          </td>
        </tr>
      }

        return (
            <div className="card-block">
                <table className="table table-striped">
                    <thead>
                    <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">วันที่ใช้จ่าย</th>
                        <th className="text-center">สาขา</th>
                        <th className="text-center">รายละเอียด</th>
                        <th className="text-center">ไฟล์เอกสาร</th>
                        <th className="text-center">ยอดค่าใช้จ่าย</th>
                        <th className="text-center">ผู้บันทึก</th>
                        <th className="text-center">ลบ</th>
                    </tr>
                    </thead>
                    <tbody>
                    {car_expense_list}
                    </tbody>
                </table>

                <Modal isOpen={this.state.preview_image_select} toggle={this.togglePreviewImage} className={'modal-lg '}>
                    <ModalBody>
                        <PreviewImage
                            imageUrl={this.state.preview_image_url}
                        />
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    user: state.auth.user,
    token: state.auth.token,
    isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps) (CarExpenseList)